import * as yup from 'yup';
import { checkDate, checkName, checkAccents, checkSpecialChars } from './utils';

// const validation = {
//     required: 'This is required',
//     phone: 'Phone number is not valid',
//     agree: 'You must agree with the terms and conditions',
//     email: 'Email is not valid',
//     sin: 'SIN is not valid',
//     date: 'Date is not valid'
// };

const phoneRegExp = /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/;

export const formDefaultValues = {
    loan: {
        amount: '',
        type: '',
        interestRate: '0',
        rateid: '',
        term: '',
        amortization: '',
        frequency: '',
        purpose: '',
        fundsNeededDate: '',
        product: {
            id: '',
            title: '',
            isPromo: false
        },
        coBorrower: false,
        payment: 0,
        showPayment: true,
        comment: '',
        branch: '',
        termSelect: '',
        isMultiBranch: false
    },
    applicants: [
        {
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            address: {
                location: '',
                city: '',
                postalCode: '',
                unit: '',
                province: '',
                occupationtype: '',
                since: '',
                poBox: ''
            },
            email: '',
            phone: '',
            sin: '',
            memberKey: '',
            employments: [
                {
                    employer: '',
                    since: '',
                    earning: '',
                    phone: '',
                    occupation: '',
                    status: ''
                }
            ],
            assets: [{ type: '', value: '', id: '' }],
            liabilities: [{ type: '', balance: '', id: '', payment: '' }]
        }
    ],
    checkedAgree: false,
    lang: ''
};

export const validationSchema = (t) => {
    const requiredMsg = t('validation.required');
    return [
        null,
        yup.object({
            loan: yup.object({
                amount: yup.string().required(requiredMsg),
                frequency: yup.string().required(requiredMsg),
                purpose: yup.string().required(requiredMsg),
                term: yup.string().required(requiredMsg),
                interestRate: yup.string().required(requiredMsg),
                fundsNeededDate: yup
                    .string()
                    .required(requiredMsg)
                    .test('dateIsValid', t('validation.date'), checkDate('funds')),
                termSelect: yup.string().required(requiredMsg)
            })
        }),
        yup.object({
            applicants: yup.array().of(
                yup.object().shape({
                    firstName: yup
                        .string()
                        .required(requiredMsg)
                        .test('nameIsValid', t('validation.name'), checkName),
                    lastName: yup
                        .string()
                        .required(requiredMsg)
                        .test('nameIsValid', t('validation.lastName'), checkName),
                    dateOfBirth: yup
                        .string()
                        .required(requiredMsg)
                        .test('dateIsValid', t('validation.date'), checkDate('birthday')),
                    address: yup.object({
                        location: yup.string().required(requiredMsg),
                        city: yup.string().required(requiredMsg),
                        province: yup.string().required(requiredMsg),
                        postalCode: yup.string().required(requiredMsg),
                        since: yup
                            .string()
                            .required(requiredMsg)
                            .test('dateIsValid', t('validation.date'), checkDate('other')),
                        occupationtype: yup.string().required(requiredMsg)
                    }),
                    email: yup
                        .string()
                        .email(t('validation.email'))
                        .required(requiredMsg)
                        .test('checkAccents', t('validation.email'), checkAccents),
                    phone: yup
                        .string()
                        .required(requiredMsg)
                        .matches(phoneRegExp, t('validation.phone'))
                })
            )
        }),
        yup.object({
            applicants: yup.array().of(
                yup.object().shape({
                    employments: yup.array().of(
                        yup.object().shape({
                            employer: yup.string().when('status', {
                                is: (status) => status !== 'U',
                                then: yup
                                    .string()
                                    .required(requiredMsg)
                                    .test('checkSpecialChars', t('validation.employer'), checkSpecialChars)
                            }),
                            since: yup.string().when('status', {
                                is: (status) => status !== 'U',
                                then: yup
                                    .string()
                                    .required(requiredMsg)
                                    .test('dateIsValid', t('validation.date'), checkDate('other'))
                            }),
                            earning: yup.string().when('status', {
                                is: (status) => status !== 'U',
                                then: yup.string().required(requiredMsg)
                            }),
                            occupation: yup.string().when('status', {
                                is: (status) => status !== 'U',
                                then: yup.string().required(requiredMsg)
                            }),
                            status: yup.string().required(requiredMsg)
                        })
                    )
                })
            ),
            loan: yup.object({
                branch: yup.string().when('isMultiBranch', {
                    is: (isMultiBranch) => isMultiBranch === true,
                    then: yup.string().required(requiredMsg)
                })
            }),
            checkedAgree: yup.boolean().oneOf([true], t('validation.agree'))
        })
    ];
}
